import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Button } from "@/components/Buttons/index";
import ProfileIconImage from "@/components/Images/ProfileIconImage";
import styles from "@/styles/Profile.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useCallback, useRef } from "react";
import { useForm } from "react-hook-form";
import * as y from "yup";
var IconCaution = function IconCaution(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.916,11.11,7.5.285a.577.577,0,0,0-1,0L.083,11.11a.588.588,0,0,0,.5.89H13.418A.588.588,0,0,0,13.916,11.11Zm-6.045-.531H6.128V8.816H7.871Zm0-2.939H6.128v-4.7H7.871Z",
      transform: "translate(0 0)",
      fill: "#eb7d3c"
    })
  }));
};
IconCaution.defaultProps = {
  viewBox: "0 0 14 12"
};
import { HiddenField, PasscodeField } from "./Parts/index";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const schema = y.object().shape({
  passcode: y.string().matches(/^\d{4}$/, "暗証番号を入力してください")
});
export default function ProfilePasscodeForm(_ref) {
  var _errors$passcode;
  let {
    profile,
    back,
    onSubmit,
    error,
    resetPin,
    type
  } = _ref;
  const submitBtnRef = useRef();
  const {
    formState,
    trigger,
    register,
    handleSubmit,
    errors
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all"
  });
  const {
    isValid,
    isSubmitting
  } = formState;
  const handleChange = useCallback(() => {
    trigger("passcode");
  }, [submitBtnRef]);
  useEffect(() => {
    if (isValid) {
      submitBtnRef.current.focus();
    }
  }, [isValid]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [type == "auth" && /*#__PURE__*/_jsx("h2", {
      children: "\u6697\u8A3C\u756A\u53F7\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044"
    }), /*#__PURE__*/_jsx("form", {
      onSubmit: handleSubmit(onSubmit),
      noValidate: true,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles["passcode-form"],
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.passcode,
          children: [type == "auth" && /*#__PURE__*/_jsx(ProfileIconImage, _objectSpread({}, profile)), /*#__PURE__*/_jsxs("div", {
            className: styles["passcode-input"],
            children: [/*#__PURE__*/_jsx("h3", {
              children: "\u6697\u8A3C\u756A\u53F7\u5165\u529B"
            }), /*#__PURE__*/_jsx(PasscodeField, {
              ref: register,
              error: (_errors$passcode = errors.passcode) === null || _errors$passcode === void 0 ? void 0 : _errors$passcode.message,
              onChange: handleChange,
              initialFocus: true
            }), error && /*#__PURE__*/_jsxs("span", {
              className: styles.errorMessage,
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.iconCaution,
                children: /*#__PURE__*/_jsx(IconCaution, {})
              }), error.message]
            }), (profile === null || profile === void 0 ? void 0 : profile.ownerProfile) && type == "auth" && resetPin && /*#__PURE__*/_jsx("div", {
              className: styles["passwordReminder"],
              children: /*#__PURE__*/_jsx(Button, {
                type: "button",
                fillColor: true,
                fontFixed: true,
                onClick: resetPin,
                children: "\u304A\u5FD8\u308C\u306E\u65B9\u306F\u6697\u8A3C\u756A\u53F7\u30EA\u30BB\u30C3\u30C8\u30E1\u30FC\u30EB\u3092\u9001\u308B"
              })
            }), !(profile !== null && profile !== void 0 && profile.ownerProfile) && type == "auth" && /*#__PURE__*/_jsxs("div", {
              className: styles["passwordReminder"],
              children: ["\u304A\u5FD8\u308C\u306E\u65B9\u306F\u30A2\u30AB\u30A6\u30F3\u30C8\u30DA\u30FC\u30B8\u304B\u3089", /*#__PURE__*/_jsx("br", {}), "\u6697\u8A3C\u756A\u53F7\u3092\u30EA\u30BB\u30C3\u30C8\u3057\u3066\u304F\u3060\u3055\u3044\u3002"]
            })]
          })]
        }), type == "auth" && /*#__PURE__*/_jsxs("fieldset", {
          className: styles.buttons,
          children: [/*#__PURE__*/_jsx(HiddenField, {
            ref: register,
            name: "id",
            value: profile.id
          }), /*#__PURE__*/_jsx(Button, {
            type: "button",
            onClick: back,
            borderGray: true,
            fillGray: true,
            medium: true,
            children: "\u623B\u308B"
          }), /*#__PURE__*/_jsx(Button, {
            ref: submitBtnRef,
            type: "submit",
            fillColor: true,
            medium: true,
            disabled: !isValid,
            loading: isSubmitting,
            children: "\u5207\u308A\u66FF\u3048\u308B"
          })]
        }), type == "reset" && /*#__PURE__*/_jsx("fieldset", {
          className: styles.buttons,
          children: /*#__PURE__*/_jsx(Button, {
            ref: submitBtnRef,
            type: "submit",
            fillColor: true,
            medium: true,
            disabled: !isValid,
            loading: isSubmitting,
            children: "\u5909\u66F4\u3059\u308B"
          })
        })]
      })
    })]
  });
}